import React, { useEffect, useState } from 'react';
import { Button, Row, Col, Modal, Tooltip, OverlayTrigger, Accordion, Card } from 'react-bootstrap'
import AuthService from "../controllers/AuthService";
import UserService from "../controllers/UserService";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import $ from 'jquery'



const EvaluateTeacher = props => {

    const [name, setName] = useState('');
    const [headline, setHeadline] = useState('');
    const [description, setDescription] = useState('');
    const [logoPath, setLogoPath] = useState('');
    const [questionStrength, setQuestionStrength] = useState('');
    const [questionTextBox, setQuestionTextBox] = useState('');
    const [postAnswer, setPostAnswer] = useState([]);
    const [strengths, setStrengths] = useState([]);
    const [modalChooseIndex, setModalChooseIndex] = useState(null);
    const [answer, setAnswer] = useState([]);
    const [modalShow, setModalShow] = useState(false);
    const [modalAnswer, setModalAnswer] = useState(null);
    const [iconChooseIndex, setIconChooseIndex] = useState(null);
    const [modalShowEndActivity, setModalShowEndActivity] = useState(false);
    const [modalShowEndActivityType, setModalShowEndActivityType] = useState('');
    const [alreadyAnswer, setAlreadyAnswer] = useState(false);
    const [targetId, setTargetId] = useState(null);
    const handleActiveIndex = (index) => { if ($(`${index}.card.active`)[0]) { $('.card').removeClass('active'); } else { $('.card').removeClass('active'); $(index).addClass('active'); } };

    useEffect(() => {
      
        setAnswer([
            { 'answer': '', 'image': '', 'name': '', 'description': '' },
            { 'answer': '', 'image': '', 'name': '', 'description': '' },
            { 'answer': '', 'image': '', 'name': '', 'description': '' },
            { 'answer': '' }
        ])

        const userId = AuthService.getCurrentUser().id
        // setLogoPath(UserService.getLogoUrl());
        setLogoPath(`/images/evaluate/school_2.png`)
        UserService.getStrengths().then((response) => {
            setStrengths(response.data.data)
            return response.data.data
        }).then((apiStrengths) => {
            UserService.getFriendShipList(userId).then((response) => {
                if (response.data.status.code === 'SUCCESS' && response.data.data && response.data && response.data.data[0] && response.data.data[0].targets) {
                    const targets = response.data.data[0].targets
                    const index = targets.findIndex(target => target.user.roles.includes("TEACHER"));
                    const data = targets[index]
                    console.log(data)
                    if (data.answers && data.answers.length > 0) {
                        setAlreadyAnswer(true)
                        handleAlreadyAnswer(apiStrengths, data.answers)
                    }
                    setTargetId(data.user.id)
                    setName(data.user.fullName)
                }
            });
        });

        UserService.getEvaluationForms('default').then((res) => {
            if (res.data && res.data.status && res.data.status.code === "SUCCESS") {
                setHeadline(res.data.data.headline)
                setDescription(res.data.data.description)
                setQuestionTextBox(res.data.data.questions[3].title)
                setPostAnswer([
                    {
                        "title": res.data.data.questions[0].title,
                        "type": res.data.data.questions[0].type,
                        "values": []
                    },
                    {
                        "title": res.data.data.questions[1].title,
                        "type": res.data.data.questions[1].type,
                        "values": []
                    },
                    {
                        "title": res.data.data.questions[2].title,
                        "type": res.data.data.questions[2].type,
                        "values": []
                    },
                    {
                        "title": res.data.data.questions[3].title,
                        "type": res.data.data.questions[3].type,
                        "values": []
                    }
                ])
                setQuestionStrength([
                    res.data.data.questions[0].title,
                    res.data.data.questions[1].title,
                    res.data.data.questions[2].title
                ])
            }
        })
    }, [])

    return (
        <div >
            <Row className="bg-light-blue">
                <Col xs={12} md={12} className="w-100 text-center pt-4 ">
                    <h2 class="font-sarabun-bold primary-text " >{headline}</h2>
                </Col>
            </Row>
            <Row style={{ "paddingBottom": "17px" }} className="bg-light-blue">
                <Col className="main-evaluate-overview pb-3">
                    <Row>
                        <Col xs={12} md={12} className="w-100 m-center-d-left pt-3">
                            <h4 class="font-sarabun-bold text-left">{description}</h4>
                        </Col>
                        <Col xs={12} md={12} className="text-center p-0 ">
                            <div className="bg-evaluate">
                                <div class="evaluate-position-absolute w-100">
                                    <div class="div-percent-image w-100">
                                        <img src={logoPath} class="percent-image shadow-image" alt="" />
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Row className="">
                <Col className="main-evaluate-overview">
                    <Row className="mx-2">
                        <Col xs={12} md={12} className="evaluate-person">
                            <div class="text-center p-1 px-3 bg-lightness2-blue border-radius-12 border-blue" style={{ "width": "fit-content", "margin": "auto" }}>{name}</div>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Row className="pb-5">
                <Col className="main-evaluate-overview">
                    <Row>
                        <Col className="w-100 text-center">
                            <h4 class="font-sarabun-bold"><img src='/images/evaluate/search.png' class="evaluate-search" />  ลองค้นหาอุปนิสัยเชิงบวกในตัวของคุณ</h4>
                        </Col>
                    </Row>
                    <Row>
                        <Col>

                        </Col>
                    </Row>
                    <Row className="mx-3 mb-3">
                        <Col xs={4} md={4} className="text-center p-1">
                            <img src={(answer[0] && answer[0].image) ? answer[0].image : '/images/evaluate/question.png'} className="w-100 pt-1 px-md-0 pb-md-2 w-100 click-pointer" onClick={() => { focusChooseStrengthModal(0); }} />
                            {(!alreadyAnswer && answer[0] && answer[0].answer) &&
                                (<a href="javascript:;" onClick={() => { callChooseStrengthModal(0); }}><img src="/images/icons/pencil.png" className="edit" />แก้ไข</a>)}
                        </Col>
                        <Col xs={4} md={4} className="text-center p-1">
                            <img src={(answer[1] && answer[1].image) ? answer[1].image : '/images/evaluate/question.png'} className="w-100 pt-1 px-md-0 pb-md-2 w-100 click-pointer" onClick={() => { focusChooseStrengthModal(1); }} />
                            {(!alreadyAnswer && answer[1] && answer[1].answer) &&
                                (<a href="javascript:;" onClick={() => { callChooseStrengthModal(1); }}><img src="/images/icons/pencil.png" className="edit" />แก้ไข</a>)}
                        </Col>
                        <Col xs={4} md={4} className="text-center p-1">
                            <img src={(answer[2] && answer[2].image) ? answer[2].image : '/images/evaluate/question.png'} className="w-100 pt-1 px-md-0 pb-md-2 w-100 click-pointer" onClick={() => { focusChooseStrengthModal(2); }} />
                            {(!alreadyAnswer && answer[2] && answer[2].answer) &&
                                (<a href="javascript:;" onClick={() => { callChooseStrengthModal(2); }}><img src="/images/icons/pencil.png" className="edit" />แก้ไข</a>)}
                        </Col>
                    </Row>
                    {
                        (answer[iconChooseIndex]) ?
                            <Row>
                                <Col className="w-100 px-4 mb-4">
                                    <div className="answer-detail">
                                        {
                                            (iconChooseIndex !== null && questionStrength[iconChooseIndex]) ?
                                                <h5 className="choice" align="center">
                                                    {/* {questionStrength[iconChooseIndex]} */}
                                                    อุปนิสัยเชิงบวกที่มองเห็นในช่วงที่ผ่านมา
                                                </h5>
                                                :
                                                <span></span>
                                        }
                                        {
                                            (answer[iconChooseIndex] && answer[iconChooseIndex].description) ?
                                                <div>
                                                    <h5 className="title" align="center">
                                                        {answer[iconChooseIndex].name}
                                                    </h5>
                                                    <p>{answer[iconChooseIndex].description}</p>
                                                </div>
                                                :
                                                <span></span>
                                        }
                                    </div>
                                </Col>
                            </Row>
                            :
                            <div></div>
                    }
                    <Row>
                        <Col className="w-100 px-4">
                            <h4 class="font-sarabun-bold">{questionTextBox}</h4>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="w-100 px-4 pt-3">
                            <div className={`border-radius-12 border-blue p-3 text-left overflow-7 ${alreadyAnswer ? 'div-ans' : 'bg-white'}`}>
                                <textarea className={`w-100 text no-border-line evaluate-placeholder ${alreadyAnswer ? 'div-ans' : ''}`} value={answer && answer[3] && answer[3].answer ? answer[3].answer : ''} placeholder="ลองเล่าให้เราฟังหน่อย..." style={{ height: '170px' }} onChange={handleTextAnswer} readOnly={alreadyAnswer}></textarea>
                            </div>
                        </Col>
                    </Row>
                    {
                        (!alreadyAnswer) ?
                            <Row>
                                <Col xs={12} className="px-3 pt-4 pb-3 d-inline w-100 text-center">
                                    <Button className="bluesky d-inline py-1 py-1 py-md-2 btn font-sarabun-bold" onClick={() => { validateForm(); }} >บันทึก</Button>
                                </Col>
                            </Row>
                            :
                            <div></div>
                    }
                </Col>
            </Row>

            <MyVerticallyCenteredModal
                show={modalShow}
                onShow={() => {preventDoubleAnswer()}}
                onHide={() => { setModalShow(false); setModalAnswer(null); }}
            />
            <Modal
                show={modalShowEndActivity}
                onHide={() => { setModalShowEndActivity(false); }}
                aria-labelledby="contained-modal-title-vcenter"
                // className="strength-modal"
                centered
                className="alert-modal"
            >
                {(modalShowEndActivityType === 'validate') ? (
                    <Modal.Body className="font-sarabun text-center py-4">
                        <p>กรุณาค้นหาอุปนิสัยเชิงบวกให้ครบก่อนจะทำการบันทึก</p>
                        <Button className="bluebtn d-inline py-1 py-md-2 px-3 font-sarabun-bold border-radius-10" onClick={() => { setModalShowEndActivity(false); }}>กลับกิจกรรม</Button>
                    </Modal.Body>
                ) : (
                    <Modal.Body className="font-sarabun text-center py-4">
                        <p>ระบบได้ทำการบันทึกข้อมูลเรียบร้อยแล้วค่ะ</p>
                        <Button className="bluebtn d-inline py-1 py-md-2 px-3 font-sarabun-bold border-radius-10" onClick={() => { setAlreadyAnswer(true); setModalShowEndActivity(false); }}>ตกลง</Button>
                    </Modal.Body>
                )}
            </Modal>
        </div>
    )

    function MyVerticallyCenteredModal(props) {
        return (
            <Modal
                {...props}
                size="xl"
                aria-labelledby="contained-modal-title-vcenter"
                className="strength-modal"
                centered
            >
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    <Row className="py-3 person-choose-strength px-md-4 d-none d-md-flex">
                        <Col xs={12} align="center">
                            <h3 class="font-sarabun-bold"><img src='/images/evaluate/search.png' class="evaluate-search" />
                                {
                                    (questionStrength[modalChooseIndex]) ?
                                        <span>
                                            {/* {questionStrength[modalChooseIndex]} */}
                                            อุปนิสัยเชิงบวกที่มองเห็นในช่วงที่ผ่านมา
                                        </span>
                                        :
                                        <span></span>
                                }
                            </h3>
                        </Col>
                        {strengths.map((strength, i) => (
                            <div key={i} className="col-12 col-md-4" align="left">
                                <OverlayTrigger
                                    placement="bottom"
                                    delay={{ show: 100, hide: 300 }}
                                    overlay={
                                        <Tooltip id="button-tooltip" className='custom-bottom-tooltip' {...props}>
                                            {strength.description}
                                        </Tooltip>
                                    }
                                >
                                    <div className={`item my-1 my-md-2 p-1 click-pointer border-radius-5 ${strength.id}`} onClick={() => { handleAnswer(strength); setModalShow(false); }}>
                                        <img className="step-img" width="58" src={strength.imageUrl} /> {strength.name}
                                    </div>
                                </OverlayTrigger>
                            </div>
                        ))}
                    </Row>
                    <Row className="d-flex d-md-none person-collapse">
                        <Col xs={12} align="center">
                            <h3 class="font-sarabun-bold"><img src='/images/evaluate/search.png' class="evaluate-search" />
                                {
                                    (questionStrength[modalChooseIndex]) ?
                                        <span>
                                            {/* {questionStrength[modalChooseIndex]} */}
                                            อุปนิสัยเชิงบวกที่มองเห็นในช่วงที่ผ่านมา
                                        </span>
                                        :
                                        <span></span>
                                }
                            </h3>
                        </Col>
                        <Col>
                            <Accordion>
                                {strengths.map((strength, i) => (
                                    <Card key={`mobi-${i}`} className={`mobi-${i} ${strength.id}`}>
                                        <Accordion.Toggle as={Card.Header} eventKey={i + 1} onClick={() => { handleActiveIndex(`.mobi-${i}`) }}>
                                            <img className="step-img" width="52" src={strength.imageUrl} />  {strength.name}
                                            <div class="arrow">
                                                <FontAwesomeIcon icon={faChevronDown} />
                                            </div>
                                        </Accordion.Toggle>
                                        <Accordion.Collapse eventKey={i + 1}>
                                            <Card.Body>
                                                <div>
                                                    {strength.description}
                                                </div>
                                                <div align="center">
                                                    <Button className="choose-btn" onClick={() => { handleAnswer(strength); setModalShow(false); }}
                                                    // disabled={answer[0].answer === strength.id || answer[1].answer === strength.id || answer[2].answer === strength.id}
                                                    >เลือก</Button>
                                                </div>

                                            </Card.Body>
                                        </Accordion.Collapse>
                                    </Card>
                                ))}
                            </Accordion>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        );
    }

    function validateForm() {
        if (
            answer && answer[0] && answer[1] && answer[2] && answer[3] &&
            answer[0].answer && answer[1].answer &&
            answer[2].answer && answer[3].answer
        ) {
            saveAnswer()
        } else {
            setModalShowEndActivity(true)
            setModalShowEndActivityType('validate')
        }
    }

    function saveAnswer() {
        UserService.postPersonEvaluationForms({
            "userId": AuthService.getCurrentUserId(),
            "targetId": targetId,
            "roomId": AuthService.getCurrentUser().room.id,
            "answers": postAnswer
        },
            (error) => {
                const resMessage =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();
                if (error.response && error.response.data && error.response.data.status && error.response.data.status.code === 'UNAUTHORIZED') {
                    AuthService.logout();
                    window.location.href = '/login'
                } else {
                    alert(`เกิดข้อผิดพลาดบางอย่าง กรุณา capture หน้าจอนี้แล้วแจ้งผู้ประสานงาน : ${resMessage}`)
                }
            }).then((res) => {
                console.log(res)
                if (res.data && res.data.status.code === 'SUCCESS') {
                    setModalShowEndActivity(true)
                    setModalShowEndActivityType('complete')
                }
            })
    }

    function handleTextAnswer(event) {
        const answerData = [...answer]
        const postAnswerData = [...postAnswer]
        if (answerData.length > 0) {
            answerData[3].answer = event.target.value
            postAnswerData[3].values = [event.target.value]
            setAnswer(answerData)
            setPostAnswer(postAnswerData)
        }
    }

    function handleAnswer(strength) {
        const answerData = [...answer]
        const postAnswerData = [...postAnswer]
        console.log(answerData)
        if (answerData.length > 0 && strength.id !== null && strength.imageUrl !== null) {
            for (let [i, val] of answerData.entries()) {
                if (i !== modalAnswer && val.image) {
                    val.image = val.image.replace("/active", "/inactive");
                }
            }
            answerData[modalAnswer].answer = strength.id
            answerData[modalAnswer].name = strength.name
            answerData[modalAnswer].description = strength.description
            const filename = strength.imageUrl.replace(/^.*[\\\/]/, '')
            answerData[modalAnswer].image = `/images/strengths/active/${filename}`
            postAnswerData[modalAnswer].values = [strength.id]
            console.log(postAnswerData)
            setAnswer(answerData)
            setPostAnswer(postAnswerData)
            setIconChooseIndex(modalChooseIndex)
        }
    }

    function callChooseStrengthModal(index) {
        if (!alreadyAnswer) {
            setModalShow(true);
            setModalAnswer(index);
            setModalChooseIndex(index);
        }
    }

    function focusChooseStrengthModal(index) {
        const answerData = [...answer]
        if (answerData && answerData.length > 0 && answerData[index] && answerData[index].answer) {
            for (let [i, val] of answerData.entries()) {
                if (i !== index && val.image) {
                    val.image = val.image.replace("/active", "/inactive");
                }
            }
            answerData[index].image = answerData[index].image.replace("/inactive", "/active");
            setAnswer(answerData)
            setIconChooseIndex(index)
        } else {
            setModalShow(true);
            setModalAnswer(index);
            setModalChooseIndex(index);
        }
    }

    function handleAlreadyAnswer(apiStrengths, answers) {
        const str0 = apiStrengths.filter(function (strength) { return strength.id === answers[0].values[0] })[0];
        const str1 = apiStrengths.filter(function (strength) { return strength.id === answers[1].values[0] })[0];
        const str2 = apiStrengths.filter(function (strength) { return strength.id === answers[2].values[0] })[0];
        if (str0 && str0.imageUrl && str1 && str1.imageUrl && str2 && str2.imageUrl) {
            const imgPath0 = str0.imageUrl.replace(/^.*[\\\/]/, '')
            const imgPath1 = str1.imageUrl.replace(/^.*[\\\/]/, '')
            const imgPath2 = str2.imageUrl.replace(/^.*[\\\/]/, '')
            setAnswer([
                { 'answer': answers[0].values[0], 'image': `/images/strengths/inactive/${imgPath0}`, 'name': str0.name, 'description': str0.description },
                { 'answer': answers[1].values[0], 'image': `/images/strengths/inactive/${imgPath1}`, 'name': str1.name, 'description': str1.description },
                { 'answer': answers[2].values[0], 'image': `/images/strengths/inactive/${imgPath2}`, 'name': str2.name, 'description': str2.description },
                { 'answer': answers[3].values[0] }
            ])
            // checkPercentAnswer(); 
        }
    }

    function preventDoubleAnswer() {
        $('.person-choose-strength .item').addClass('click-pointer');
        $('.person-choose-strength .item').css("pointer-events", "unset");
        $('.person-choose-strength .item').css("opacity", "1");
        var imgsrc = '';
        $(".strengths-box img.w-100").each(function() {  
            imgsrc = this.src;           
            var tempText = imgsrc.split('/');    
            tempText = tempText[tempText.length-1];
            tempText = "." + tempText.replace(".png", "");
            console.log(tempText);
            console.log( $(tempText));
            $(tempText).removeClass('click-pointer');
            $(tempText).css("pointer-events", "none");
            $(tempText).css("opacity", "0.4");         

        });  
    }

}

export default EvaluateTeacher